export default __webpack_public_path__ + "static/media/TX_Elemental_Water_Grimory.a1309c94.png";